// extracted by mini-css-extract-plugin
export default {"link":"ModerationDropdownContainer-link-b4aa16ef29583c8acd3eaf8e5d5a46b7"};